import { useNavigate } from "react-router-dom";
import { FileText } from "lucide-react";
import PageMeta from "./PageMeta";

const documentLinks = [
  { name: "RSAA Safeguarding Policy",        file: "/assets/Safeguarding_Policy.pdf" },
  { name: "Club Rules",                       file: "/assets/rsaa_club_rules.pdf" },
  { name: "RSAA Constitution",               file: "/assets/rsaa_constitution.pdf" },
  { name: "Club Fixtures",                    file: "/assets/club_fixtures_2026.pdf" },
  { name: "Boat Risk Assessments",            file: "/assets/Boat_Risk_Assessments.pdf" },
  { name: "Boat Safety Report",               file: "/assets/rsaa_boat_safety_report.pdf" },
  { name: "Shore Risk Assessment",            file: "/assets/Shore_Fishing_Risk_Assessment.pdf" },
  { name: "Month Long Boat Competitions",     file: "/assets/month_long_boat_comps.pdf" },
  { name: "Month Long Shore Competitions",    file: "/assets/month_long_shore_comps.pdf" },
  { name: "RSAA Species Hunt Rules",          file: "/assets/rsaa_species_hunt_rules.pdf" },
  { name: "Weighing Scales Policy",           file: "/assets/rsaa_weighing_scales_policy.pdf" },
  { name: "Use of Social Media by RSAA and Juniors - consent form", file: "/assets/rsaa_parential_consent_form.pdf" },
];

export default function DocumentsPage() {
  const navigate = useNavigate();

  return (
    <div className="page-shell min-h-screen bg-gradient-to-b from-slate-950 via-slate-900 to-slate-950 text-white">
      <PageMeta title="Club Documents | Redruth Sea Angling Association" noindex />
      <div className="mx-auto max-w-5xl px-4 py-10 sm:px-6 lg:px-8">
        <div className="mb-8 flex items-center gap-4">
          <button type="button" onClick={() => navigate(-1)}
            className="standalone-only group inline-flex items-center gap-1.5 rounded-full border border-cyan-400/20 bg-white/5 px-4 py-2 text-sm font-medium text-slate-200 shadow-lg shadow-black/20 backdrop-blur transition hover:-translate-x-0.5 hover:border-cyan-300/40 hover:bg-cyan-400/10 hover:text-white">
            ← Back
          </button>
          <div>
            <h1 className="heading-glow text-2xl font-bold text-white sm:text-3xl">Club Documents</h1>
            <p className="mt-1 text-sm text-slate-400">RSAA Rules, policies, and competition documents</p>
          </div>
        </div>

        <p className="text-sm font-semibold uppercase tracking-[0.3em] text-cyan-300">Rules and documents</p>
        <h2 className="mt-4 text-3xl font-bold tracking-tight text-white sm:text-4xl">RSAA Club Documents</h2>
        <p className="mt-4 text-sm leading-7 text-slate-400">All club rules, policies, and competition documents are available to download below. Click any document to open it as a PDF.</p>

        <div className="mt-8 grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {documentLinks.map((doc) => (
            <a
              key={doc.file}
              href={doc.file}
              target="_blank"
              rel="noopener noreferrer"
              className="rounded-[1.6rem] border border-white/10 bg-white/5 p-5 text-left transition hover:border-cyan-300/30 hover:bg-cyan-400/5 block panel-lift"
            >
              <FileText className="h-6 w-6 text-cyan-300" />
              <p className="mt-4 text-lg font-semibold text-white">{doc.name}</p>
            </a>
          ))}
        </div>
      </div>
    </div>
  );
}
